module.exports = __webpack_public_path__ + "img/C.837824e2.jpg";